import { PartiposterProfile, SubmissionState } from 'state/submissions'
import { REGISTRATION_STATUS_ENUM, RegistrationBlock } from 'services/api/registrations'
import { RegistrationResultState } from 'state/registrations'
import { TaskState } from 'state/tasks'
import { ActionModalProps } from 'state/constants'
import { TagContentType } from 'particles/Tag'
import { GridColDef } from '@mui/x-data-grid-pro'

type TimestampKey = 'created_at' | 'approved_at' | 'accepted_at' | 'declined_at'

interface PartipostTagsRow {
    profileData: PartiposterProfile
    submissionUuid: string
    campaignUuid: string
}
interface FirstContentSubmittedRow {
    value: string
    color?: string
}

export interface DefaultRowsProps {
    id: string
    name?: {
        value: string
        color?: string
    }
    gender?: {
        value: string
        color?: string
    }
    igUsername?: {
        account: string | null
        socialDomain: string
    }
    igFollowers?: {
        value: string
    }
    fbUsername?: {
        account: string | null
        socialDomain: string
    }
    fbFriends?: {
        value: string
    }
    tiktokUsername?: {
        account: string | null
        socialDomain: string
    }
    tiktokFollowers?: {
        value: string
    }
    twitterUsername?: {
        account: string | null
        socialDomain: string
    }
    twitterFollowers?: {
        value: string
    }
    xiaohongshuUsername?: {
        account: string | null
        socialDomain: string
    }
    xiaohongshuFollowers?: {
        value: string
    }
    age?: number
    created_at?: {
        value: string
    }
    approved_at?: {
        value: string
    }
    accepted_at?: {
        value: string
    }
    declined_at?: {
        value: string
    }
}

export interface RegistrationResultTableRows extends DefaultRowsProps {
    occupation?: { value: string }
    location?: {
        value: {
            live_location: Record<string, number>
            work_location: Record<string, number>
            hangout_location: Record<string, number>
        }
    }
    first_content_submitted_at: FirstContentSubmittedRow
    partiposterTags: PartipostTagsRow
    lastReviewedBy: {
        value?: string
    }
    lastReviewedAt: {
        value?: string
    }
}
export interface DropoutsTableRows extends DefaultRowsProps {
    partiposterTags: PartipostTagsRow
}

export interface DeclinedRegistrationResultsTableRows extends DefaultRowsProps {
    first_content_submitted_at: FirstContentSubmittedRow
    lastReviewedBy: {
        value?: string
    }
    lastReviewedAt: {
        value?: string
    }
    partiposterTags: PartipostTagsRow
}

export interface RejectedTableRows extends DefaultRowsProps {
    rejectionReason: {
        submission: SubmissionState
        contentType: TagContentType
    }
    rejectedBy: {
        value: string
    }
    rejectedOn: {
        value: string
    }
    partiposterTags: PartipostTagsRow
}
export interface CompletedTimeTableRows extends DefaultRowsProps {
    completedTime: {
        value: string
    }
    partiposterTags: PartipostTagsRow
}

export interface WaitListTableRows extends DefaultRowsProps {
    action: {
        registration: RegistrationResultState
        registrationFormBlocksById: Record<string, RegistrationBlock>
        campaignUuid: string
        profile: PartiposterProfile
        igUserName?: string | null
        hasFbTask: TaskState | undefined
        fbUserName?: string | null
        onOpenActionDetailModal: (actionProps: ActionModalProps) => void
    }
}

export const TIMESTAMP_KEY: Record<string, TimestampKey> = {
    [REGISTRATION_STATUS_ENUM.PENDING]: 'created_at',
    [REGISTRATION_STATUS_ENUM.AWAITING_RESPONSE]: 'approved_at',
    [REGISTRATION_STATUS_ENUM.ACCEPTED_INVITES]: 'accepted_at',
    [REGISTRATION_STATUS_ENUM.JOINED_CAMPAIGN]: 'accepted_at',
    [REGISTRATION_STATUS_ENUM.DECLINED_INVITES]: 'declined_at',
}

export interface GridColDefProps extends GridColDef {
    subFields?: {
        field: string
        headerName: string
    }[]
}
